export default {"src":"/_next/static/media/period.ca39c548.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};